import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { HomePage } from './HomePage';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    loader: async () => <HomePage />,
  },
});

/**
 * The landing page, as its own plugin.
 *
 * `pluginId` is deliberately NOT 'home': @backstage/plugin-home is installed
 * (for its Visits API) and already owns that id, so reusing it would collide.
 * It is not on `portalPlugin` either — that plugin is titled "Catalog", and
 * PluginHeader renders the plugin title as the leading breadcrumb, so the home
 * page would have come out filed under the catalog.
 *
 * The stock home page itself is switched off in app-config (`page:home: false`)
 * so nothing of plugin-home reaches the screen; only its visits API and route
 * listener stay on.
 */
export const homePlugin = createFrontendPlugin({
  pluginId: 'dashboard',
  title: 'Home',
  extensions: [homePage],
});
